module.exports = __webpack_public_path__ + "static/img/存@3x.b73fc8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/存@3x.png
// module id = kA0A
// module chunks = 192